import Cookies from "js-cookie";

export function setCookie(cookieName: string, cookieData: any) {
  Cookies.set(cookieName, JSON.stringify(cookieData), { expires: 2 });
}

export function getCookie(cookieName: string) {
  const cookieValue = Cookies.get(cookieName);
  if (cookieValue) {
    return JSON.parse(cookieValue);
  }
  return null;
}

export function removeCookie(cookieName: string) {
  Cookies.remove(cookieName);
}
